interface IFolderTreeIconProps {
  iconUrl?: string;
}

/**
 * common folder tree icon DOM
 *
 * Copyright (c) 2023 Decisions All Rights Reserved
 */
export function FolderTreeIcon({ iconUrl }: IFolderTreeIconProps) {
  return iconUrl ? <img className="dp-folder-tree__icon" src={iconUrl} alt="" /> : null;
}
